module.exports = ".d3-chart {\r\n    margin: auto;\r\n    text-align:center;\r\n    display: inline-block;\r\n    position: relative;\r\n    width: 100%;\r\n    padding-bottom: 100%;\r\n    vertical-align: top;\r\n    overflow: hidden;    \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/grouped-barchart/grouped-barchart.component.css
// module id = ./src/app/grouped-barchart/grouped-barchart.component.css
// module chunks = main